unit InvoiceRemittanceViewerPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  EditBaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Grids;

type
  TInvoiceRemittanceViewerForm = class(TBaseEditForm)
    DataTable: TDBTableControl;
    RemittanceDataSource: TDataSource;
    InvoiceTotal: TDBEdit;
    DueDateEdit: TDBDateTimePicker;
    PaidInFullCheckbox: TDBCheckBox;
    procedure DataSourceDataChange(Sender: TObject; Field: TField);
    procedure DataTableGetCellData(Sender: TObject; ACol, ARow: Integer;
      AField: TField; var AValue: string);
  private
    { Private declarations }

  protected
    function GetRequiredEditLevel: string; override;

  public
    { Public declarations }

  protected procedure LoadDFMValues; override; end;

var
  InvoiceRemittanceViewerForm: TInvoiceRemittanceViewerForm;

implementation

{$R *.dfm}

uses
  App.Shared,
  MainDataModule,
  XData.Web.Dataset;

function TInvoiceRemittanceViewerForm.GetRequiredEditLevel: string;
begin
  Result :=
    USER_SCOPES[TUserScope.Administrator] + ',' +
    USER_SCOPES[TUserScope.Customer];

end;

procedure TInvoiceRemittanceViewerForm.DataSourceDataChange(Sender: TObject;
  Field: TField);
begin
  inherited;

  if (Sender is TDataSource) and (Sender <> nil) then
  begin
    InvoiceTotal.Text := Format('£%m', [ TDataSource(Sender).DataSet.FieldByName('GrossAmount').AsFloat ]);

  end;

end;

procedure TInvoiceRemittanceViewerForm.DataTableGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  inherited;

  if Assigned(AField) then
  begin
    if AField.FieldName = 'Amount' then
    begin
      if AField.IsNull then
        AValue := ''
      else
        AValue := Format('£%m', [ AField.AsFloat ]);

    end;

  end
  else
  begin
    // don't clear header row
    if ARow <> 0 then
      AValue := '';

  end;

end;

procedure TInvoiceRemittanceViewerForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  DataTable := TDBTableControl.Create('data-table-remittances');
  InvoiceTotal := TDBEdit.Create('invoice-gross-amount-edit');
  DueDateEdit := TDBDateTimePicker.Create('invoice-due-date-edit');
  PaidInFullCheckbox := TDBCheckBox.Create('paid-in-full');
  RemittanceDataSource := TDataSource.Create(Self);

  DataTable.BeforeLoadDFMValues;
  InvoiceTotal.BeforeLoadDFMValues;
  DueDateEdit.BeforeLoadDFMValues;
  PaidInFullCheckbox.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  RemittanceDataSource.BeforeLoadDFMValues;
  try
    Caption := 'RemittanceDataset';
    DataTable.SetParentComponent(Self);
    DataTable.Name := 'DataTable';
    DataTable.Left := 56;
    DataTable.Top := 144;
    DataTable.Width := 433;
    DataTable.Height := 200;
    DataTable.HeightStyle := ssAuto;
    DataTable.WidthStyle := ssAuto;
    DataTable.BorderColor := clSilver;
    DataTable.ChildOrder := 9;
    DataTable.ElementFont := efCSS;
    DataTable.ElementHeaderClassName := 'thead-light';
    DataTable.ElementPosition := epIgnore;
    DataTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    DataTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    DataTable.Footer.ButtonElementClassName := 'btn btn-light';
    DataTable.Footer.DropDownElementClassName := 'form-control';
    DataTable.Footer.InputElementClassName := 'form-control';
    DataTable.Footer.LinkActiveElementClassName := 'link-primary';
    DataTable.Footer.LinkElementClassName := 'link-secondary';
    DataTable.Footer.ListElementClassName := 'pagination';
    DataTable.Footer.ListItemElementClassName := 'page-item';
    DataTable.Footer.ListLinkElementClassName := 'page-link';
    DataTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    DataTable.Header.ButtonElementClassName := 'btn btn-light';
    DataTable.Header.DropDownElementClassName := 'form-control';
    DataTable.Header.InputElementClassName := 'form-control';
    DataTable.Header.LinkActiveElementClassName := 'link-primary';
    DataTable.Header.LinkElementClassName := 'link-secondary';
    DataTable.Header.ListElementClassName := 'pagination';
    DataTable.Header.ListItemElementClassName := 'page-item';
    DataTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(DataTable, Self, 'OnGetCellData', 'DataTableGetCellData');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'Id';
      Title := 'Id';
      Width := 80;
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'RemittanceDate';
      Title := 'Remittance Date';
      Width := 180;
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Amount';
      Title := 'Amount';
      Width := 120;
    end;
    DataTable.DataSource := RemittanceDataSource;
    InvoiceTotal.SetParentComponent(Self);
    InvoiceTotal.Name := 'InvoiceTotal';
    InvoiceTotal.Left := 512;
    InvoiceTotal.Top := 144;
    InvoiceTotal.Width := 121;
    InvoiceTotal.Height := 22;
    InvoiceTotal.ChildOrder := 10;
    InvoiceTotal.ElementClassName := 'form-control';
    InvoiceTotal.ElementFont := efCSS;
    InvoiceTotal.ElementPosition := epIgnore;
    InvoiceTotal.HeightStyle := ssAuto;
    InvoiceTotal.HeightPercent := 100.000000000000000000;
    InvoiceTotal.ReadOnly := True;
    InvoiceTotal.Text := 'InvoiceTotal';
    InvoiceTotal.WidthStyle := ssAuto;
    InvoiceTotal.WidthPercent := 100.000000000000000000;
    InvoiceTotal.DataField := 'GrossAmount';
    InvoiceTotal.DataSource := DataSource;
    DueDateEdit.SetParentComponent(Self);
    DueDateEdit.Name := 'DueDateEdit';
    DueDateEdit.Left := 512;
    DueDateEdit.Top := 208;
    DueDateEdit.Width := 170;
    DueDateEdit.Height := 22;
    DueDateEdit.ElementClassName := 'form-control';
    DueDateEdit.HeightStyle := ssAuto;
    DueDateEdit.WidthStyle := ssAuto;
    DueDateEdit.BorderStyle := bsSingle;
    DueDateEdit.ChildOrder := 12;
    DueDateEdit.Color := clWhite;
    DueDateEdit.Date := 45884.634804155100000000;
    DueDateEdit.ElementFont := efCSS;
    DueDateEdit.ElementPosition := epIgnore;
    DueDateEdit.ReadOnly := True;
    DueDateEdit.Role := '';
    DueDateEdit.Text := '';
    DueDateEdit.DataField := 'DueDate';
    DueDateEdit.DataSource := DataSource;
    PaidInFullCheckbox.SetParentComponent(Self);
    PaidInFullCheckbox.Name := 'PaidInFullCheckbox';
    PaidInFullCheckbox.Left := 512;
    PaidInFullCheckbox.Top := 236;
    PaidInFullCheckbox.Width := 113;
    PaidInFullCheckbox.Height := 22;
    PaidInFullCheckbox.Caption := 'PaidInFullCheckbox';
    PaidInFullCheckbox.ChildOrder := 12;
    PaidInFullCheckbox.ElementClassName := 'custom-control custom-checkbox';
    PaidInFullCheckbox.ElementButtonClassName := 'custom-control-input';
    PaidInFullCheckbox.ElementLabelClassName := 'custom-control-label';
    PaidInFullCheckbox.ElementFont := efCSS;
    PaidInFullCheckbox.ElementPosition := epIgnore;
    PaidInFullCheckbox.HeightStyle := ssAuto;
    PaidInFullCheckbox.HeightPercent := 100.000000000000000000;
    PaidInFullCheckbox.WidthStyle := ssAuto;
    PaidInFullCheckbox.WidthPercent := 100.000000000000000000;
    PaidInFullCheckbox.DataField := 'PaidInFull';
    PaidInFullCheckbox.DataSource := DataSource;
    DataSource.Left := 288;
    DataSource.Top := 16;
    RemittanceDataSource.SetParentComponent(Self);
    RemittanceDataSource.Name := 'RemittanceDataSource';
    RemittanceDataSource.Left := 664;
    RemittanceDataSource.Top := 40;
  finally
    DataTable.AfterLoadDFMValues;
    InvoiceTotal.AfterLoadDFMValues;
    DueDateEdit.AfterLoadDFMValues;
    PaidInFullCheckbox.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    RemittanceDataSource.AfterLoadDFMValues;
  end;
end;

end.